var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSipBArrowdecb954D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 282.462,
    height: 546.065,
    viewBox: "0 0 282.462 546.065",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_165767",
    "data-name": "Group 165767",
    transform: "translate(76.334 -106.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116533",
    "data-name": "Path 116533",
    d: "M8449.666,670.159s175.69,0,96-201.953-33.509-312.439,143.993-326.023",
    transform: "translate(-8525 -19)",
    fill: "none",
    stroke: "#f45e29",
    strokeLinecap: "round",
    strokeWidth: 2,
    strokeDasharray: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116534",
    "data-name": "Path 116534",
    d: "M21.06.125A1.88,1.88,0,0,1,22.253,1.6l3.976,26.24a1.878,1.878,0,0,1-.814,1.841,1.9,1.9,0,0,1-2.019.056L.924,16.443a1.876,1.876,0,0,1-.24-3.065l5.1-4.2a1.894,1.894,0,0,1,2.659.25,1.873,1.873,0,0,1-.25,2.646l-3.032,2.5,16.742,9.9L19.017,5.446l-2.966,2.44a1.9,1.9,0,0,1-1.981.264l-1.849-.832,3.524,4.219a1.874,1.874,0,0,1-.245,2.648,1.893,1.893,0,0,1-2.659-.244L4.073,3.442a1.873,1.873,0,0,1-.05-2.34A1.894,1.894,0,0,1,6.3.528l8.249,3.713,4.63-3.81A1.893,1.893,0,0,1,21.06.125Z",
    transform: "matrix(0.643, -0.766, 0.766, 0.643, 166.273, 126.203)",
    fill: "#f45e29"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSipBArrowdecb954D);
export default __webpack_public_path__ + "static/media/sip-b-arrow.decb954d.decb954dd6fba8549e36f7b931be66df.svg";
export { ForwardRef as ReactComponent };